import '@babel/polyfill';
import Vuex from 'vuex';
import { shallowMount, createLocalVue } from '@vue/test-utils';
import VueRouter from 'vue-router';
import boostMixin from '../../../../mixins/boostMixin';
import CustomizeYourKit from './CustomizeYourKit';
import { mutations } from '../../../../store/modules/xsell';
import { currency } from '../../../../filters';

const localVue = createLocalVue();
localVue.use(Vuex);
localVue.use(VueRouter);
localVue.filter('currency', currency);

let store;
var wrapper;
const router = new VueRouter();
let computed = {};

const createWrapper = (store) => {
  return shallowMount(CustomizeYourKit, {
    store,
    router,
    localVue,
    computed,
    mixins: [boostMixin]
  });
};

const boosts = [
  {
    id: 1,
    name: 'Boost 1',
    price: 5,
    inventory_status: 'active',
    imagery: {
      standard: {
        url: 'www.url',
        alt_text: 'Alt Text'
      }
    }
  },
  {
    id: 2,
    name: 'Boost 2',
    price: 5,
    inventory_status: 'active',
    imagery: {
      standard: {
        url: 'www.url',
        alt_text: 'Alt Text'
      }
    }
  },
  {
    id: 3,
    name: 'Boost 3',
    price: 5,
    inventory_status: 'active',
    imagery: {
      standard: {
        url: 'www.url',
        alt_text: 'Alt Text'
      }
    }
  }
];

let showModalMock = jest.fn();
let initWaitlistsMock = jest.fn();
let initBoostRecommendationsMock = jest.fn();
let isOnWaitlistMock = jest.fn();
let setBoostQtyMock = jest.fn();
let addSubAttachmentMock = jest.fn();
let loadRefillCartMock = jest.fn();
let initRefillCartMock = jest.fn();
let addToRefillCart = jest.fn();

let storeObj = {
  modules: {
    waitlist: {
      namespaced: true,
      state: {},
      actions: {
        initWaitlists: initWaitlistsMock
      },
      getters: {
        isOnWaitlist: () => () => false
      }
    },

    xsell: {
      namespaced: true,
      state: {
        boostRecommendations: boosts,
        showBoostOptions: false,
        selectedBoost: {
          id: 123,
          qty: 1
        }
      },
      actions: {
        initBoostRecommendations: initBoostRecommendationsMock,
      },
      mutations: {
        setSelectedBoost: mutations.setSelectedBoost,
        setBoostQty: setBoostQtyMock,
        setShowBoostOptions: mutations.setShowBoostOptions
      }
    },

    modal: {
      namespaced: true,
      actions: {
        showModal: showModalMock
      }
    },

    subscriptions: {
      namespaced: true,
      getters: {
        nextSubShipment: () => [{ id: 321 }]
      },

      actions: {
        addSubAttachment: addSubAttachmentMock
      }
    },

    refillCart: {
      namespaced: true,
      state: {
        refillCart: {
          nextShipment: {
            sub_id: 567
          }
        }
      },
      getters: {
        productIdInRefillCart: () => () => false,
        qtyByProductTypeInRefillCart: () => () => 0
      },
      actions: {
        loadRefillCart: loadRefillCartMock,
        addToRefillCart: addToRefillCart,
        initRefillCart: initRefillCartMock
      }
    }
  }
};

function clearMocks() {
  initWaitlistsMock.mockClear();
  initBoostRecommendationsMock.mockClear();
  isOnWaitlistMock.mockClear();
  setBoostQtyMock.mockClear();
  addSubAttachmentMock.mockClear();
  loadRefillCartMock.mockClear();
  initRefillCartMock.mockClear();
  addToRefillCart.mockClear();
}

describe('CustomizeYourKit', () => {

  afterEach(() => {
    clearMocks();
  });

  describe('view state', () => {
    afterAll(()=> {
      computed = {};
    });

    test('render .info-wrap section when showOptions is false', () => {
      store = new Vuex.Store(storeObj);
      computed = { 
        showOptions: () => false
      };
      wrapper = createWrapper(store);

      expect(wrapper.find('.info-wrap').exists()).toBe(true);
      expect(wrapper.find('.boost-sub-wrap').exists()).toBe(false);
      expect(wrapper.find('.ship-wrap').exists()).toBe(false);
    });

    test('does not render .info-wrap section when showOptions is true', () => {
      store = new Vuex.Store(storeObj);
      computed = {
        showOptions: () => true
      };
      wrapper = createWrapper(store);

      wrapper.vm.setShowBoostOptions(true);
      expect(wrapper.find('.info-wrap').exists()).toBe(false);
      expect(wrapper.find('.boost-sub-wrap').exists()).toBe(true);
      expect(wrapper.find('.ship-wrap').exists()).toBe(true);
    });
  });


  test('click on Whats a boost button', () => {
    store = new Vuex.Store(storeObj);
    wrapper = createWrapper(store);
    wrapper.setMethods({ showBoostModal: jest.fn() });

    let whatsBtn = wrapper.find('.whats-btn');
    whatsBtn.trigger('click');

    expect(wrapper.vm.showBoostModal).toHaveBeenCalledTimes(1);
  });

  describe('computed', () => {

    describe('boostImgClasses', () => {
      const localThis = { showOptions: false };

      test('with showOptions = false', () => {
        expect(CustomizeYourKit.computed.boostImgClasses.call(localThis)).toEqual(['xs-12', 'md-6']);
      });

      test('with showOptions = true', () => {
        localThis.showOptions = true;
        expect(CustomizeYourKit.computed.boostImgClasses.call(localThis)).toEqual(['xs-3', 'sm-3', 'md-6', 'showing-options']);
      });
    });

    describe('combinedBoostQty', () => {
      const localThis = {
        boostRefillCartQty: 0,
        selectedBoostQty: 1
      };

      test('sum of boostRefillCartQty: 0 and selectedBoostQty: 1', () => {
        expect(CustomizeYourKit.computed.combinedBoostQty.call(localThis)).toEqual(1);
      });

      test('sum of boostRefillCartQty: 2 and selectedBoostQty: 1', () => {
        localThis.boostRefillCartQty = 2;
        expect(CustomizeYourKit.computed.combinedBoostQty.call(localThis)).toEqual(3);
      });

      test('sum of boostRefillCartQty: 2 and selectedBoostQty: 2', () => {
        localThis.boostRefillCartQty = 2;
        localThis.selectedBoostQty = 2;
        expect(CustomizeYourKit.computed.combinedBoostQty.call(localThis)).toEqual(4);
      });

      test('sum of boostRefillCartQty: 2 and selectedBoostQty: 1', () => {
        localThis.boostRefillCartQty = 2;
        localThis.selectedBoostQty = 1;

        expect(CustomizeYourKit.computed.combinedBoostQty.call(localThis)).toEqual(3);
      });
    });

    describe('selectedBoostPriceTotal', () => {
      const localThis = {
        boostRefillCartQty: 0,
        selectedBoostQty: 1,
        selectedBoost: { price: 5 }
      };

      test('selectedBoostQty is 1', () => {
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(5);
      });

      test('selectedBoostQty is 2', () => {
        localThis.selectedBoostQty = 2;

        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(10);
      });

      test('selectedBoostQty is 3', () => {
        localThis.selectedBoostQty = 3;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(15);
      });

      test('selectedBoostQty is 4', () => {
        localThis.selectedBoostQty = 4;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(16);
      });

      test('selectedBoostQty is 5', () => {
        localThis.selectedBoostQty = 5;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(21);
      });

      test('selectedBoostQty is 7', () => {
        localThis.selectedBoostQty = 7;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(31);
      });

      test('selectedBoostQty is 8', () => {
        localThis.selectedBoostQty = 8;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(32);
      });

      test('selectedBoostQty is 9', () => {
        localThis.selectedBoostQty = 9;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(37);
      });

      test('selectedBoostQty is 1 and nextShipment boost qty is 1', () => {
        localThis.selectedBoostQty = 1;
        localThis.boostRefillCartQty = 1;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(5);
      });

      test('selectedBoostQty is 1 and nextShipment boost qty is 2', () => {
        localThis.selectedBoostQty = 1;
        localThis.boostRefillCartQty = 2;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(5);
      });

      test('selectedBoostQty is 1 and nextShipment boost qty is 3', () => {
        localThis.selectedBoostQty = 1;
        localThis.boostRefillCartQty = 3;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(1);
      });

      test('selectedBoostQty is 1 and nextShipment boost qty is 4', () => {
        localThis.selectedBoostQty = 1;
        localThis.boostRefillCartQty = 4;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(5);
      });

      test('selectedBoostQty is 2 and nextShipment boost qty is 3', () => {
        localThis.selectedBoostQty = 2;
        localThis.boostRefillCartQty = 3;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(6);
      });

      test('selectedBoostQty is 2 and nextShipment boost qty is 1', () => {
        localThis.selectedBoostQty = 2;
        localThis.boostRefillCartQty = 1;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(10);
      });

      test('selectedBoostQty is 2 and nextShipment boost qty is 2', () => {
        localThis.selectedBoostQty = 2;
        localThis.boostRefillCartQty = 2;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(6);
      });

      test('selectedBoostQty is 2 and nextShipment boost qty is 3', () => {
        localThis.selectedBoostQty = 2;
        localThis.boostRefillCartQty = 3;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(6);
      });

      test('selectedBoostQty is 1 and nextShipment boost qty is 4', () => {
        localThis.selectedBoostQty = 1;
        localThis.boostRefillCartQty = 4;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(5);
      });

      test('selectedBoostQty is 4 and nextShipment boost qty is 4', () => {
        localThis.selectedBoostQty = 4;
        localThis.boostRefillCartQty = 4;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(16);
      });

      test('selectedBoostQty is 2 and boostRefillCartQty is 4', () => {
        localThis.selectedBoostQty = 2;
        localThis.boostRefillCartQty = 2;
        expect(CustomizeYourKit.computed.selectedBoostPriceTotal.call(localThis)).toEqual(6);
      });
    });

    describe('addButtonText', () => {
      const localThis = { subscribeToBoost: false };

      test('text when subscribeToBoost is false', () => {
        expect(CustomizeYourKit.computed.addButtonText.call(localThis)).toEqual('Add to Next Shipment ');
      });

      test('text when subscribeToBoost is true', () => {
        localThis.subscribeToBoost = true;
        expect(CustomizeYourKit.computed.addButtonText.call(localThis)).toEqual('Add to Every Shipment ');
      });
    });
  });

  describe('methods', () => {
    beforeEach(() => {
      store = new Vuex.Store(storeObj);

      wrapper = createWrapper(store);
    });

    afterEach(() => {
      clearMocks();
    });

    describe('showBoostModal', () => {
      test('expected method calls with arguments', () => {
        wrapper.vm.showBoostModal();
        expect(showModalMock).toHaveBeenCalledTimes(1);
        expect(showModalMock.mock.calls[0][1]).toEqual({ component: './Dashboard/Welcome/ReturnCustomer/BoostModal', theme: 'no-padding' });
      });
    });

    describe('onQtyChange', () => {
      test('update selectedBoostQty', () => {
        wrapper.vm.onQtyChange(2);
        expect(setBoostQtyMock).toHaveBeenCalledTimes(1);
        expect(setBoostQtyMock.mock.calls[0][1]).toEqual(2);

        wrapper.vm.onQtyChange(3);
        expect(setBoostQtyMock).toHaveBeenCalledTimes(2);
        expect(setBoostQtyMock.mock.calls[1][1]).toEqual(3);

        wrapper.vm.onQtyChange(1);
        expect(setBoostQtyMock).toHaveBeenCalledTimes(3);
        expect(setBoostQtyMock.mock.calls[2][1]).toEqual(1);
      });
    });

    describe('addBoost', () => {
      test('add boost to subscription', () => {
        let boost = {
          id: 123,
          qty: 1,
          subscribe: true
        };

        let expectedPayload = {
          sub_id: 567,
          product_id: boost.id,
          qty: boost.qty,
          ctaSource: "Customize Your Kit"
        };

        wrapper.vm.setSelectedBoost(boost);
        wrapper.vm.addBoost();

        expect(addSubAttachmentMock).toHaveBeenCalledTimes(1);
        expect(addToRefillCart).toHaveBeenCalledTimes(0);
        expect(addSubAttachmentMock).toHaveBeenCalledWith(expect.any(Object), expectedPayload, undefined);
      });

      test('add boost to refill cart', () => {
        let boost = {
          id: 123,
          qty: 1,
          subscribe: false
        };

        let expectedPayload = {
          product_id: boost.id,
          qty: boost.qty,
          ctaSource: 'Customize Your Kit',
        };

        wrapper.vm.setSelectedBoost(boost);
        wrapper.vm.addBoost();

        expect(addToRefillCart).toHaveBeenCalledTimes(1);
        expect(addSubAttachmentMock).toHaveBeenCalledTimes(0);
        expect(addToRefillCart).toHaveBeenCalledWith(expect.any(Object), expectedPayload, undefined);
      });
    });
  });
});
